var map = {
	"./de/translation.json": [
		27254,
		"assets_i18n_de_translation_json"
	],
	"./en/translation.json": [
		8062,
		"assets_i18n_en_translation_json"
	],
	"./es/translation.json": [
		40469,
		"assets_i18n_es_translation_json"
	],
	"./fr/translation.json": [
		51869,
		"assets_i18n_fr_translation_json"
	],
	"./klingon/translation.json": [
		83943,
		"assets_i18n_klingon_translation_json"
	],
	"./nl/translation.json": [
		50887,
		"assets_i18n_nl_translation_json"
	],
	"./vulcan/translation.json": [
		47278,
		"assets_i18n_vulcan_translation_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 99188;
module.exports = webpackAsyncContext;